import React from "react";

export const LazyQualifyAccountPage = React.lazy(
  () => import("modules/investorRole/pages/AccountsPage/QualifyAccountPage"),
);
